<script>
import ItemListItem from './item-list-item.vue';
export default {
  components: { ItemListItem },
  props: {
    items: {
      type: Array,
      required: true
    },
    limit: {
      type: Number,
      required: false,
      default: null
    },
    expandable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isExpanded: false
    }
  },
  computed: {
    limitedItems() {
      return this.isExpanded === false && this.limit !== null? this.items.slice(0, this.limit) : this.items;
    },
    isLimited() {
      return this.isExpanded === false && this.limit !== null && this.items.length > this.limit;
    }
  }
}
</script>
<template>
    <div>
      <ul :class="$style.list">
        <ItemListItem v-for="(item, itemIndex) in limitedItems" :key="itemIndex" :item="item" />
      </ul>
      <p v-if="expandable && isLimited" @click="isExpanded = true">
        <span role="button">{{ $t('item_list.show_more', [items.length - limitedItems.length]) }} <i :class="$style.arrow"></i></span>
      </p>
      <p v-if="expandable && isExpanded" @click="isExpanded = false">
        <span role="button">{{ $t('item_list.show_less') }} <i :class="[$style.arrow,$style['arrow-up']]"></i></span>
      </p>
    </div>
</template>
<style lang="scss" module>
@import '@design';
.list {
    display: flex;
    flex-wrap: wrap;
    margin: $size-grid-size / -2;

    @media screen and (min-width: $size-breakpoint-lg) {
      margin: -$size-grid-size;
    }
}
.arrow {
  display: inline-block;
  width: 12px;
  height: 17px;
  vertical-align: middle;
  background-image: url(@assets/images/arrow-down.svg);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
}
.arrow-up {
  transform: rotate(180deg);
}
</style>